import { useEffect, useState } from "react";
import baseUrl from "../../api/baseUrl";
import type { DentistOption } from "./LabOrderForm";

type DentistRow = { _id: string; title?: string; firstName?: string; lastName?: string };

let cache: DentistOption[] | null = null;

function label(d: DentistRow) {
  const name = [d.firstName, d.lastName].filter(Boolean).join(" ").trim();
  const title = String(d.title || "").replace(/\.$/, "").trim();
  if (name) return title ? `${title}. ${name}` : `Dr. ${name}`;
  return title || "Doctor";
}

/** The clinic's doctors for the lab order Doctor dropdown (loaded once). */
export function useClinicDentists(enabled = true) {
  const [dentists, setDentists] = useState<DentistOption[]>(cache ?? []);
  useEffect(() => {
    if (!enabled || cache) return;
    let cancelled = false;
    baseUrl
      .get("/appointment/findAllAppointmentDentist")
      .then((res) => {
        const rows: DentistRow[] = Array.isArray(res.data?.data) ? res.data.data : [];
        cache = rows.map((d) => ({ id: String(d._id), name: label(d) }));
        if (!cancelled) setDentists(cache);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [enabled]);
  return dentists;
}
